import { jsx } from "react/jsx-runtime";
import SvgIcon from "@mui/material/SvgIcon/index.js";
const SuccessIcon = (props) => {
  return /* @__PURE__ */ jsx(SvgIcon, { ...props, viewBox: "0 0 24 24", sx: { width: 24, height: 24 }, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11.4956 8.21693C11.5371 8.02166 11.6924 7.88658 11.8669 7.86962C11.925 7.86397 11.9854 7.87091 12.0444 7.89363C12.3977 8.02887 12.8265 8.33883 12.8265 9.04705C12.8265 9.82245 12.4133 10.8634 12.4133 10.8634H15.3058C15.7604 10.8634 16.1323 11.2585 16.1323 11.7415V12.1549C16.1323 12.3349 16.0964 12.5129 16.0274 12.6771L14.7869 15.6434C14.6625 15.9407 14.3853 16.1322 14.0791 16.1322H10.7604C10.3038 16.1322 9.93392 15.7392 9.93392 15.2541V11.2004C9.93392 10.9835 10.0094 10.7741 10.1462 10.613L11.2664 9.2906L11.4956 8.21693ZM7.86781 11.522C7.86781 11.1584 8.14549 10.8634 8.48764 10.8634C8.82979 10.8634 9.10748 11.1584 9.10748 11.522V15.4736C9.10748 15.8372 8.82979 16.1322 8.48764 16.1322C8.14549 16.1322 7.86781 15.8372 7.86781 15.4736V11.522Z"
    }
  ) });
};
export {
  SuccessIcon
};
